<div class="basicrow m-top" *ngIf="this.typeAccount=='Movil'">
  <div class="autowcont mbott">
    <div class="basicrow msidespad">
      <div class="b-title">
        <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
          <div class="tabcell">
            Equipo
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow msidespad roboto-r m-bott f-reg f-black">
      <div class="device-i roboto-b text-center">
        <img width="100%" class="devimg" src="{{mobile_image}}" *ngIf="this.showimgDef == true">
        <img width="100%" class="devimg" src="https://miclaro.clarotodo.com/ImageHandler/OracleImageHandler.ashx?DEVICE_ID=56571H"  *ngIf="this.showimgDef == false">
        {{this.equipment_name}}
      </div>
      <div class="device-i middle">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Detalle del Equipo
          </div>

          <div class="redstat m-top-ii" *ngIf="this.itemBrandField!='not_set'">
            <div class="autorow roboto-r pull-left">
              Marca
            </div>

            <div class="autorow roboto-b pull-right">
              {{this.itemBrandField}}
            </div>
            <div class="autorow roboto-b pull-right" *ngIf="this.itemBrandField==null">
              N/A
            </div>
          </div>

          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              IMEI
            </div>

            <div class="autorow roboto-b pull-right">
              {{this.eSNField[this.index]}}
            </div>
          </div>

          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              SIM CARD
            </div>

            <div class="autorow roboto-b pull-right">
              {{this.sIMField[this.index]}}
            </div>
          </div>

          <div class="redstat m-top-ii" style="display: none;">
            <div class="autorow roboto-r pull-left">
              Garant&iacute;a hasta
            </div>

            <div class="autorow roboto-b pull-right">
              {{this.dateWarranty | date:'MM/dd/yyyy'}}
            </div>
          </div>

          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Tecnolog&iacute;a
            </div>

            <div class="autorow roboto-b pull-right">
             {{this.techField}}
            </div>
            <div class="autorow roboto-b pull-right" *ngIf="this.techField==null">
              N/A
             </div>
          </div>
        </div>
      </div>
      <div class="device-i last roboto-r text-center" *ngIf="this.instal_equ > 0">
        <div class="basicrow m-top-u roboto-b">
          Equipos a Plazos
        </div>

        <div class="basicrow roboto-m f-semi f-red">
         {{this.val_ins_equ|currency}}
        </div>

        <div class="basicrow roboto-b f-mgray">
          Pagos restantes: {{this.instal_equ}}
        </div>

      </div>
      <div class="device-i last roboto-r text-center vertical" *ngIf="this.instal_equ == 0||this.instal_equ == null">
        <div class="basicrow m-top-u roboto-b">
          N/A
        </div>

      </div>

    </div>
  </div>
</div>
